import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { ExternalEntityAssociationViewModel } from '../../../models/Entities/Person/ExternalAssociation/ExternalAssociationModels';

// store
import * as PersonExternalAssociationsStore from '../../../redux/middleware/PersonExternalAssociations.Middleware';

export interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  PersonId: number;
  externalAssociationId?: number | undefined;
}

interface ConnectedProps {
  isAdding: boolean | undefined;
  successAdding: boolean | undefined;
  failAdding: boolean | undefined;
  isUpdating: boolean | undefined;
  successUpdating: boolean | undefined;
  failUpdating: boolean | undefined;
  error: ErrorType | undefined;
  externalAssociation?: ExternalEntityAssociationViewModel;
}

interface DispatchProps {
  CreateExternalAssociation: typeof PersonExternalAssociationsStore.actionCreators.CreateExternalAssociation;
  UpdateExternalAssociation: typeof PersonExternalAssociationsStore.actionCreators.UpdateExternalAssociation;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isAdding: state.PersonExternalAssociations?.isAddingNewOne,
  successAdding: state.PersonExternalAssociations?.successAddingNewOne,
  failAdding: state.PersonExternalAssociations?.failOnAddingNewOne,
  isUpdating: state.PersonExternalAssociations?.isUpdatingOne,
  successUpdating: state.PersonExternalAssociations?.successUpdatingOne,
  failUpdating: state.PersonExternalAssociations?.failOnUpdatingOne,
  error: state.PersonExternalAssociations?.error,
  externalAssociation: state.PersonExternalAssociations?.list.find(
    (item: ExternalEntityAssociationViewModel) => item.id === ownProps.externalAssociationId
  ),
  ...ownProps
});

export const mapDispatchToProps = {
  ...PersonExternalAssociationsStore.actionCreators
};
